module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "conclusion-section d-none d-md-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "text-white text-md-right small"
  }, [_c('strong', [_vm._v("© " + _vm._s(_vm.year) + " — The International Consortium of Investigative Journalists.")]), _vm._v(" All rights reserved.\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('h5', {
    staticClass: "text-uppercase text-white"
  }, [_vm._v("\n          International Consortium of Investigative Journalists\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          910 17th Street NW Suite 410"), _c('br'), _vm._v("\n          Washington DC 20006 USA\n        ")]), _vm._v(" "), _c('p', [_c('strong', [_c('a', {
    staticClass: "text-warning",
    attrs: {
      "href": "mailto:contact@icij.org"
    }
  }, [_vm._v("contact@icij.org")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 offset-md-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h5', [_c('a', {
    staticClass: "text-warning text-uppercase",
    attrs: {
      "href": "https://www.icij.org/investigations/paradise-papers/"
    }
  }, [_vm._v("\n                Paradise Papers\n              ")])]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', {
    staticClass: "list-unstyled-item"
  }, [_c('a', {
    attrs: {
      "href": "",
      "target": "_blank"
    }
  }, [_vm._v("\n                  The Influencers\n                ")])]), _vm._v(" "), _c('li', {
    staticClass: "list-unstyled-item"
  }, [_c('a', {
    attrs: {
      "href": "",
      "target": "_blank"
    }
  }, [_vm._v("\n                  Offshore Leaks Database\n                ")])]), _vm._v(" "), _c('li', {
    staticClass: "list-unstyled-item"
  }, [_c('a', {
    attrs: {
      "href": "",
      "target": "_blank"
    }
  }, [_vm._v("\n                  The Mauritius\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h5', {
    staticClass: "text-warning text-uppercase"
  }, [_vm._v("\n              Follow us\n            ")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', {
    staticClass: "list-unstyled-item"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/ICIJ.org",
      "target": "_blank"
    }
  }, [_vm._v("\n                  Facebook\n                ")])]), _vm._v(" "), _c('li', {
    staticClass: "list-unstyled-item"
  }, [_c('a', {
    attrs: {
      "href": "https://www.linkedin.com/company/1732242/",
      "target": "_blank"
    }
  }, [_vm._v("\n                  LinkedIn\n                ")])]), _vm._v(" "), _c('li', {
    staticClass: "list-unstyled-item"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/icijorg",
      "target": "_blank"
    }
  }, [_vm._v("\n                  Twitter\n                ")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cda71aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConclusionSection.vue
// module id = 776
// module chunks = 1